import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const LOCALE = window.__LOCALE__;
const TRANSLATIONS = window.__TRANSLATIONS__;

i18n.use(initReactI18next).init({
  // Initial language
  lng: LOCALE,

  resources: {
    [LOCALE]: {
      translation: TRANSLATIONS,
    },
  },

  // Fallback language
  fallbackLng: 'en',

  // Don't use a key separator (no support for nested translation objects)
  keySeparator: false,

  // Wait for translation data to be available before rendering a component
  react: {
    useSuspense: true,
  },
});

const t = i18n.t.bind(i18n);

export { t };
export default i18n;
